import { useRouterState } from '@tanstack/react-router'
import { helpSlugFor } from './context'

/** The help article slug for the page you are on. */
export function useHelpContextSlug(): string {
  return useRouterState({
    select: (s) => {
      const leaf = s.matches[s.matches.length - 1]
      return helpSlugFor(leaf?.routeId, (leaf?.search ?? {}) as Record<string, unknown>)
    },
  })
}
